import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ContextService, LayoutInterface, LoginData, ServerServiceConfig } from '../context.service';
import { LayoutComponent } from '../layout/layout.component';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'mutara-certify-residency',
  templateUrl: './certify-residency.component.html',
  styleUrls: ['./certify-residency.component.scss'],
  standalone: false
})
export class CertifyResidencyComponent extends LayoutComponent implements OnInit {

  wasInvalid: boolean = false;
  activity: string = 'Sign In';

  constructor(
    http: HttpClient,
    actRoute: ActivatedRoute,
    router: Router,
    location: Location, 
    contextService: ContextService
  ) {
    super(http, actRoute, router, location, contextService);
  }

  loginData: LoginData;
  countries: any[];

  ngOnInit() {
    super.ngOnInit();

    this.contextService.setLayoutId(this.contextService.findLayout('Residency'));

    this.contextService.subscribeTo("applicationInfo", (config: ServerServiceConfig) => {
      this.countries = config.lookups.Countries;
    });

    this.contextService.subscribeTo("failedLogin", (failed: boolean) => {
      this.wasInvalid = failed;
    });

  }

  user: string;
  pwd: string;
  message: string;

  fields: FormlyFieldConfig[] = [
    {
      fieldGroupClassName: 'display-flex',
      fieldGroup: [
        {
          key: 'user', type: 'input',
          className: 'flex-1',
          modelOptions: {
            debounce: { default: 300 },
          },
          props: {
            label: 'Registered Email',
            placeholder: 'me@email.com',
            required: true,
          }
        },
        {
          key: 'pwd', type: 'input',
          className: 'flex-1',
          props: {
            type: 'password',
            label: 'Password',
            hidePassword: true,
            placeholder: 'bubbl3Gum!',
            required: true,
            addonRight: {
              icon: 'visibility_off',
              ariaLabel: 'Show password',
              onClick: (props, field, $event) => {
                props.hidePassword = !props.hidePassword;
                props.type = props.hidePassword ? 'password' : 'text';
                props.addonRight.ariaLabel = props.hidePassword ? 'Show password' : 'Mask password';
                props.addonRight.icon = props.hidePassword ? 'visibility_off' : 'visibility';
              }
            },
          },
        },
        {
          key: 'layout', type: 'input',
          hide: false,
          defaultValue: 'Residency',
          className: 'mutara-hidden',
          props: {
            type: 'input',
            label: 'Activity',
          }
        }]
    },
    {
      key: 'buttonList', wrappers: ['button-row'],
      props: {
        align: 'end',
      },
      fieldGroup: [
        {
          key: 'login', type: 'button',
          expressions: {
            'props.disabled': (field: FormlyFieldConfig) => !!this.fields[0].form.invalid,
          },
          props: {
            type: 'submit',
            label: 'Login',

          }
        }
      ]
    },
  ];

  processLogin(loginData) {
    if (!!loginData?.user && !!loginData?.pwd) {
      let service = '$service';
      this.http.post(service, loginData).subscribe({
        error: err => {
          console.error(err.message);
          return err;
        },
        next: (data: any) => {
        }
      });
    } else {
      this.processLogin(this.fields[0].form.value);
      this.fields[0].form.reset();
      this.router.navigate(['certify-residency']);
    }
  }
}